"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareTransaction = exports.hydrate = exports.preload = exports.modes = void 0;
const values_1 = __importDefault(require("lodash/values"));
// maintained union of all the modules
const erc20 = __importStar(require("./erc20"));
const send = __importStar(require("./send"));
const erc721 = __importStar(require("./erc721"));
const erc1155 = __importStar(require("./erc1155"));
const modules = {
    erc20,
    send,
    erc721,
    erc1155,
};
exports.modes = {};
function loadModes() {
    for (const k in modules) {
        const m = modules[k];
        if (m.modes) {
            for (const j in m.modes) {
                exports.modes[j] = m.modes[j];
            }
        }
    }
}
loadModes();
function preload(currency) {
    return __awaiter(this, void 0, void 0, function* () {
        const value = {};
        for (const k in modules) {
            const m = modules[k];
            if (m.preload) {
                value[k] = yield m.preload(currency);
            }
        }
        return value;
    });
}
exports.preload = preload;
function hydrate(value, currency) {
    if (!value || typeof value !== "object")
        return;
    for (const k in value) {
        if (k in modules) {
            const m = modules[k];
            if (m.hydrate) {
                m.hydrate(value[k], currency);
            }
        }
    }
}
exports.hydrate = hydrate;
const prepareTransaction = (account, transaction) => (0, values_1.default)(modules)
    // @ts-expect-error some module implement it
    .map(m => m.prepareTransaction)
    .filter(Boolean)
    .reduce((p, fn) => p.then(t => fn(account, t)), Promise.resolve(transaction));
exports.prepareTransaction = prepareTransaction;
//# sourceMappingURL=index.js.map